/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Member } from '../../models/member';
import { UpdateMeDto } from '../../models/update-me-dto';

export interface UpdateOneBaseMemberControllerMember$Params {
  id: number;
      body: UpdateMeDto
}

export function updateOneBaseMemberControllerMember(http: HttpClient, rootUrl: string, params: UpdateOneBaseMemberControllerMember$Params, context?: HttpContext): Observable<StrictHttpResponse<Member>> {
  const rb = new RequestBuilder(rootUrl, updateOneBaseMemberControllerMember.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Member>;
    })
  );
}

updateOneBaseMemberControllerMember.PATH = '/api/members/{id}';
